import {
    ITEM_LEDGER_REPORT_REQUEST,
    ITEM_LEDGER_REPORT_SUCCESS,
    ITEM_LEDGER_REPORT_FAILURE,
    ITEM_LEDGER_FILTER_REPORT_REQUEST,
    ITEM_LEDGER_FILTER_REPORT_SUCCESS,
    ITEM_LEDGER_FILTER_REPORT_FAILURE,
    ITEM_LEDGER_TRANSACTIONS_REQUEST,
    ITEM_LEDGER_TRANSACTIONS_SUCCESS,
    ITEM_LEDGER_TRANSACTIONS_FAILURE,
    ITEM_LEDGER_MONTH_TRANSACTIONS_REQUEST,
    ITEM_LEDGER_MONTH_TRANSACTIONS_SUCCESS,
    ITEM_LEDGER_MONTH_TRANSACTIONS_FAILURE,
    CLEAR_ITEM_LEDGER_TRANSACTIONS
  } from "../types/item-ledger-report-types";

  import {
    CREATE_ITEM_CLOSING_RATE,
    GET_ALL_ITEM_CLOSING_RATE,
    ITEM_CLOSING_RATE_REQUEST,
    UPDATE_ALL_ITEM_CLOSING_RATE,
    ITEM_CLOSING_RATE_REQUEST_FAILURE
  } from "../types/item-closing-rate-types";
  
  const initialState = {
    itemLedgerReport: {
      dates: [],
      ledger: [],
      itemTypeTable: [],
      itemGroupTable: [],
      ledgerTotal: {}
    },
    itemLedgerFilterOptions: {},
    transactions: [],
    transactionsLoading: false,
    transactionsError: null,
    monthTransactions: [],
    monthTransactionsLoading: false,
    monthTransactionsError: null,
    itemClosingRate: {},
    itemClosingRateLoading: false,
    itemClosingRateError: null,
    loading: false,
    error: null,
  };
  
  const itemLedgerReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case ITEM_LEDGER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case ITEM_LEDGER_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case ITEM_LEDGER_REPORT_SUCCESS: {
        return {
          ...state,
          itemLedgerReport: {
            ...(action.payload || {}),
            dates: action?.payload?.dates || state?.itemLedgerReport?.dates,
            ledger: action?.payload?.ledger || state?.itemLedgerReport?.ledger,
            itemTypeTable: action?.payload?.itemTypeTable || state?.itemLedgerReport?.itemTypeTable,
            itemGroupTable: action?.payload?.itemGroupTable || state?.itemLedgerReport?.itemGroupTable,
            ledgerTotal: action?.payload?.ledgerTotal || state?.itemLedgerReport?.ledgerTotal,
          },
          loading: false,
          error: null
        }
      }
      case ITEM_LEDGER_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          itemLedgerFilterOptions: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case ITEM_LEDGER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      case ITEM_LEDGER_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      case ITEM_LEDGER_TRANSACTIONS_REQUEST: {
        return {
          ...state,
          transactionsLoading: true,
          transactionsError: null,
        };
      }
      case ITEM_LEDGER_MONTH_TRANSACTIONS_REQUEST: {
        return {
          ...state,
          monthTransactionsLoading: true,
          monthTransactionsError: null,
        };
      }
      case ITEM_LEDGER_TRANSACTIONS_SUCCESS: {
        return {
          ...state,
          transactions: [...(action.payload || [])],
          transactionsLoading: false,
          transactionsError: null,
        };
      }
      case ITEM_LEDGER_MONTH_TRANSACTIONS_SUCCESS: {
        return {
          ...state,
          monthTransactions: [...(action.payload || [])],
          monthTransactionsLoading: false,
          monthTransactionsError: null,
        };
      }
      case ITEM_LEDGER_TRANSACTIONS_FAILURE: {
        return {
          ...state,
          transactionsLoading: false,
          transactionsError: action.error,
        };
      }
      case ITEM_LEDGER_MONTH_TRANSACTIONS_FAILURE: {
        return {
          ...state,
          monthTransactionsLoading: false,
          monthTransactionsError: action.error,
        };
      }
      case CLEAR_ITEM_LEDGER_TRANSACTIONS: {
        return {
          ...state,
          itemLedgerReport: {
            dates: [],
            ledger: [],
            itemTypeTable: [],
            itemGroupTable: [],
            ledgerTotal: {}
          },
          itemLedgerFilterOptions: {},
          transactions: [],
          transactionsLoading: false,
          transactionsError: null,
          monthTransactions: [],
          monthTransactionsLoading: false,
          monthTransactionsError: null,
          itemClosingRate: {},
          itemClosingRateLoading: false,
          itemClosingRateError: null,
          loading: false,
          error: null,
        };
      }
      case ITEM_CLOSING_RATE_REQUEST: {
        return {
          ...state,
          itemClosingRateLoading: true,
          itemClosingRateError: null
        }
      }
      case GET_ALL_ITEM_CLOSING_RATE: {
        return {
          ...state,
          itemClosingRate: [...action.payload],
          itemClosingRateLoading: false,
          itemClosingRateError: null
        }
      }
      case CREATE_ITEM_CLOSING_RATE: {
          return {
              ...state,
              itemClosingRate: [action.payload, ...(Array.isArray(state.itemClosingRate) ? state.itemClosingRate : [])],
              itemClosingRateLoading: false,
              itemClosingRateError: null
          };
      }
      case UPDATE_ALL_ITEM_CLOSING_RATE: {
        return {
          ...state,
          // itemClosingRate: [...action.payload],
          // itemClosingRateLoading: false,
          // itemClosingRateError: null
        };
      }
      
      case ITEM_CLOSING_RATE_REQUEST_FAILURE: {
        return {
          ...state,
          itemClosingRateLoading: false,
          itemClosingRateError: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default itemLedgerReportReducer;
  